import { render, staticRenderFns } from "./wp_user_info_banner.vue?vue&type=template&id=fe3d0060&scoped=true&"
import script from "./wp_user_info_banner.vue?vue&type=script&lang=js&"
export * from "./wp_user_info_banner.vue?vue&type=script&lang=js&"
import style0 from "./wp_user_info_banner.vue?vue&type=style&index=0&id=fe3d0060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3d0060",
  null
  
)

export default component.exports